// This file enumerates places on the site where users can log in or sign up.
// We publish these with our login-related events for data tracking purposes.

const SiteLocation = {
  GENERIC: 'generic',
  GENERIC_GOOGLE: 'generic google',
  GENERIC_FACEBOOK: 'generic facebook',
  INTERNATIONAL_GATE: 'international gate',
  MOBILE_LOGIN_GATE: 'mobile gate',
  PRODUCT_PAGE_GATE: 'product page gate',
  INTERNAL_GATE: 'internal gate',
  EXTERNAL_GATE: 'external gate',
  BANNER: 'banner',
  REFERRAL_BANNER: 'referral banner',
  EXPERIMENTAL_MOBILE_BANNER: 'experimental mobile banner',
  LEFT_HEADER: 'left header',
  RIGHT_FOOTER: 'right footer',
  FOOTER: 'footer',
  PAID_TOP_HALF: 'top half page',
  PAID_FOOTER: 'footer',
  CHECKOUT: 'checkout',
  COMING_SOON_WAITLIST: 'coming soon waitlist',
  JOBS: 'jobs page',
  GIFTCARD_REDEEM: 'giftcard redeem',
  REFERRALS: 'referrals',
  DESKTOP_PRODUCT_PAGE: 'desktop product page',
  MOBILE_PRODUCT_PAGE: 'mobile product page',
  INTERNATIONAL_LANDING_PAGE: 'international landing page',
  PRODUCT_PANTS_SLIDESHOW: 'pp content page module',
  PRODUCT_REVIEWS: 'reviews form - product page',
  DIRECT_REVIEWS: 'reviews form - email',
  MOBILE_MENU: 'mobile main menu',
  DESKTOP_HELP_PAGE_SUPPORT_FORM: 'help page support form',
  DESKTOP_HOMEPAGE_MODAL: 'desktop homepage modal',
  MOBILE_HOMEPAGE_MODAL: 'mobile homepage modal',
  MOBILE_HOMEPAGE: 'mobile homepage',
  MOBILE_COLLECTIONS: 'mobile collections',
  EXCHANGE_MODAL: 'exchange modal',
  ORDER_DETAILS_PAGE: 'order details page',
  ORDERS_AND_RETURNS_PAGE: 'orders and returns page',
  BUNDLE_MODULE: 'complete_bundle_product_page',
  RETURN_SELECTION: 'select_return_reason',
  CONFIRM_RETURN: 'confirm_return',
  COLLECTIONS_MODAL: 'collections modal',
  PRODUCTS_MODAL: 'products modal',
  PASSWORD_RESET: 'password reset',
  GUEST_CHECKOUT: 'guest checkout',
  MAGIC_LINK_LOGIN_ERROR: 'magic link login error',
  WUNDERKIND_MODAL: 'wunderkind signup modal',
}

export default SiteLocation
